import React, { useState } from 'react';
import { Theme } from '../../../../../Enums/Theme.enum';
import TherapistDetailModal from './TherapistDetailModal';
import Button from '../../../../../Components/Button/Button';

interface Props {
	userId: string;
}

const TherapistDetailButton: React.FC<Props> = ({ userId }) => {
	const [isDetailOpen, setIsDetailOpen] = useState(false);
	return (
		<>
			<Button
				title='base.myTherapistProfile'
				theme={Theme.BLUE}
				onClick={() => setIsDetailOpen(true)}
			/>
			<TherapistDetailModal
				isOpen={isDetailOpen}
				onClose={() => setIsDetailOpen(false)}
				userId={userId}
			/>
		</>
	);
};

export default TherapistDetailButton;
